import { useSearchParams } from 'react-router-dom';
import AgentForm from '../../../components/agents/AgentForm/AgentForm';
import Page from '../../../components/shared/Page/Page';

/**
 * @deprecated Will be replaced by NewCallAgent component.
 */
const NewAgent = () => {
  const [searchParams] = useSearchParams();
  const step = searchParams.get('step');

  return (
    <Page withBackground hideMainMenu>
      <AgentForm step={step ? parseInt(step, 10) : 0} />
    </Page>
  );
};

export default NewAgent;
